import { createFileRoute } from "@tanstack/react-router";
import alcatrazOgImage from "@/assets/alcatraz/alcatraz-og.jpg";
import { AlcatrazPage } from "@/components/solutions/AlcatrazPage";
import { alcatrazSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/alcatraz-dms")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    alcatrazSeo(loaderData?.href ?? "/solutions/alcatraz-dms", alcatrazOgImage),
  component: AlcatrazPage,
});
